import React, { useEffect, useState  } from 'react';
import { collection, query, where, getDocs, doc, getDoc, updateDoc, increment, setDoc, addDoc } from 'firebase/firestore';
import { db, auth } from '../firebase';
import BackHomeButton from '../components/BackHomeButton';
import { getStorage, ref, listAll, getDownloadURL } from 'firebase/storage';
import { useLocation } from 'react-router-dom';
import AutoScrollPreview from "../components/AutoScrollPreview";
import { useNavigate } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

function DownloadForms() {
  const location = useLocation();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [allForms, setAllForms] = useState([]);
  const [filteredForms, setFilteredForms] = useState([]);
  const [feedbackCounts, setFeedbackCounts] = useState({});
  const [userVotes, setUserVotes] = useState({});
  
  const [selectedType, setSelectedType] = useState(location.state?.type || 'Worksheet');
  const [selectedSchool, setSelectedSchool] = useState('My_School');
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedStandard, setSelectedStandard] = useState('My_Standard');
  
  const [sortOption, setSortOption] = useState('newest');

  const { type: incomingType, subject: incomingSubject ,lesson:incominglessonid,shared:incomingshared} = location.state || {};

  const [selectedSubject, setSelectedSubject] = useState('');
  const [selectedlessonid, setSelectedlessonid] = useState('');
  const [downloadedFileIds, setDownloadedFileIds] = useState([]);
  const [sharedFileIds, setSharedFileIds] = useState([]);
  const [hideShared, setHideShared] = useState(false);

  const [starRatings, setStarRatings] = useState({});
  const [userStarRatings, setUserStarRatings] = useState({});

  const [openId, setOpenId] = useState(null);




useEffect(() => {
  if (incomingType) setSelectedType(incomingType);
  if (incomingSubject) setSelectedSubject(incomingSubject);
  if (incominglessonid) setSelectedlessonid(incominglessonid);
  if (incomingshared) setHideShared(true);

  //alert(incomingType);
  //alert(incomingSubject);
  //alert(incominglessonid);
}, [incomingType, incomingSubject,incominglessonid]);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const formsPerPage = 5;

  useEffect(() => {
    const fetchProfileAndForms = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const profileRef = doc(db, 'profiles', user.uid);
      const profileSnap = await getDoc(profileRef);

      if (profileSnap.exists()) {
        const parsedProfile = profileSnap.data();
        setProfile(parsedProfile);

        const uploadsRef = collection(db, 'uploads');

       //const q_u = query(uploadsRef, where('fileName', '==', 'AI_Std_2_Maths_Multiple_Lesson_Multiple_Topics_worksheet'));

        let uploadsQuery = query(uploadsRef);

        //alert(selectedSubject);

        const querySnapshot = await getDocs(uploadsQuery);

        const uploadsList = [];
        querySnapshot.forEach((docSnap) => {
          const data = docSnap.data();

         //alert (data.topicName?.current );

          uploadsList.push({
            id: docSnap.id,
            title: data.calculatedFileName,
            fileLink: data.fileUrl,
            uploadedBy: data.uploadedBy || "Admin",
            downloads: data.downloads || 0,
            shares: data.shares || 0,
            avgRating: data.avgRating || 0,
            numRatings: data.numRatings || 0,
            reportCount: data.reportCount || 0,
            reportedBy: data.reportedBy || {},
            uploadTime: data.uploadTime?.toDate?.() || null,
            subject: data.subject || "Other",
            type: data.type || "Worksheet",
            standard: data.standard || "N/A",
            school: data.school || "",
            lessonName: data.lessonName || "Not Available",
            topics: Array.isArray(data.topicName?.current)
                ? data.topicName.current.join(", ")
                : String(data.topicName || "Not Available"),
          });
        });

        setAllForms(uploadsList);
        setFilteredForms(uploadsList);

        const feedbackPromises = uploadsList.map(async (form) => {
          const feedbackRef = doc(db, 'formFeedback', `form${form.id}`);
          const userVoteRef = doc(db, 'formFeedback', `form${form.id}_user_${user.uid}`);
          const [feedbackSnap, userVoteSnap] = await Promise.all([getDoc(feedbackRef), getDoc(userVoteRef)]);

          return {
            id: form.id,
            counts: feedbackSnap.exists() ? feedbackSnap.data() : { thumbsUp: 0, thumbsDown: 0 },
            vote: userVoteSnap.exists() ? userVoteSnap.data().vote : null,
          };
        });

        const results = await Promise.all(feedbackPromises);
        const counts = {};
        const votes = {};
        results.forEach(({ id, counts: c, vote }) => {
          counts[id] = c;
          votes[id] = vote;
        });

        setFeedbackCounts(counts);
        setUserVotes(votes);
      }

      //alert(profileSnap.id);

      {/*Replace downloaded with shared keep for future use*/}
      const downloadsRef = collection(db, 'Downloads_And_Generations');
      const q = query(downloadsRef, where('userId', '==', profileSnap.id));

      const snapshot = await getDocs(q);
      const fileIds = snapshot.docs.map(doc => doc.data().fileUrl); 
      // You’ll need to make sure each logged download has a fileId or fileName
      setDownloadedFileIds(fileIds);

      const sharedRef = collection(db, "Shared_Worksheets");
      const q_shared = query(sharedRef, where("friendEmail", "==", user.email));
      const snapshot_shared = await getDocs(q_shared);

      // ✅ Deduplicate using Set
      const shared_fileIds = [
        ...new Set(snapshot_shared.docs.map(doc => doc.data().fileUrl))
      ];

      setSharedFileIds(shared_fileIds);


      //alert(shared_fileIds.length);

    };

    fetchProfileAndForms();
  }, []);

  // Update filteredForms based on filters and search
  useEffect(() => {
const filtered = allForms.filter(form => {

  //alert (form.topics.toLowerCase().includes(searchQuery.toLowerCase()));

  const matchesSubject = selectedSubject === 'All Subjects' || form.subject === selectedSubject;
  const matchesType = selectedType === 'All Types' || form.type === selectedType;
  const matchesSearch = form.uploadedBy.toLowerCase().includes(searchQuery.toLowerCase()) || form.title.toLowerCase().includes(searchQuery.toLowerCase()) || form.lessonName.toLowerCase().includes(searchQuery.toLowerCase()) || form.topics.toLowerCase().includes(searchQuery.toLowerCase()) ;
  
  // ✅ Clear school logic based on dropdown value
  let matchesSchool = false; // default false
  if (selectedSchool === 'My_School' && form.school === profile.school) {
    matchesSchool = true ;
  }
  if (selectedSchool === 'All_Schools') {
    matchesSchool = true ;
  }

   let matchesStandard = false; // default false
  if (selectedStandard === 'My_Standard' && form.standard === profile.standard) {
    matchesStandard = true ;
  }
  if (selectedStandard === 'All_Standard') {
    matchesStandard = true ;
  }

    // ✅ NEW: Shared filter
  let matchesShared = true;
  if (hideShared) {
    matchesShared = sharedFileIds.includes(form.fileLink);
  }
  
    /*alert(form.school);
	alert(profile.school);*/
	//alert(matchesSchool);
	//alert(selectedSchool);
	
	//alert ('*');
	//alert(matchesSubject);
	//alert(matchesType);
	//alert(matchesSearch);

  //alert(matchesStandard);
	/*alert(selectedStandard);
	alert(form.standard);
  alert(profile.standard);*/

  return matchesSubject && matchesType && matchesSearch && matchesSchool && matchesStandard && matchesShared;
});


 // Sort logic
const sorted = [...filtered].sort((a, b) => {
  if (sortOption === 'newest') {
    return (b.uploadTime?.getTime?.() || 0) - (a.uploadTime?.getTime?.() || 0);

  } else if (sortOption === 'rating') {
  return (b.avgRating || 0) - (a.avgRating || 0);
}
else if (sortOption === 'downloads') {
    return b.downloads - a.downloads;
  }

  return 0;
});

  
    setFilteredForms(sorted);
    setCurrentPage(1); // Reset page when filters or search change
    //alert('all_forms'+allForms);
  }, [selectedSubject, selectedType, searchQuery, allForms, sortOption, feedbackCounts,selectedSchool,selectedStandard,sharedFileIds, hideShared   ]);

  // Pagination logic
  const visibleForms = filteredForms//.filter(form =>  !hideShared || !downloadedFileIds.includes(form.fileLink));
  //alert(visibleForms.length)
  //const totalPages = Math.ceil(visibleForms.length / formsPerPage);
  //const startIdx = (currentPage - 1) * formsPerPage;
  //const currentForms = visibleForms.slice(startIdx, startIdx + formsPerPage);

  const handleReport = async (form) => {
  const user = auth.currentUser;
  if (!user) return alert("Please log in to report.");

  if (form.reportedBy?.[user.uid]) {
    return alert("You already reported this worksheet.");
  }

  const reason = prompt(
    "Reason:\n1. Incorrect Content\n2. Wrong Standard\n3. Offensive\n4. Other"
  );

  if (!reason) return;

  try {
    const uploadRef = doc(db, "uploads", form.id);

    await updateDoc(uploadRef, {
      reportCount: increment(1),
      [`reportedBy.${user.uid}`]: true
    });

    // Update UI immediately
    setAllForms(prev =>
      prev.map(f =>
        f.id === form.id
          ? {
              ...f,
              reportCount: (f.reportCount || 0) + 1,
              reportedBy: {
                ...f.reportedBy,
                [user.uid]: true
              }
            }
          : f
      )
    );

    setFilteredForms(prev =>
      prev.map(f =>
        f.id === form.id
          ? {
              ...f,
              reportCount: (f.reportCount || 0) + 1,
              reportedBy: {
                ...f.reportedBy,
                [user.uid]: true
              }
            }
          : f
      )
    );

    alert("Reported successfully.");
  } catch (error) {
    console.error("Report error:", error);
    alert("Failed to report.");
  }
};

const handleStarRating = async (formId, rating) => {
  const user = auth.currentUser;
  if (!user) return alert("Please log in to rate.");

  setUserStarRatings(prev => ({ ...prev, [formId]: rating }));

  try {
    const ratingDocRef = doc(db, "formRatings", formId);
    const uploadDocRef = doc(db, "uploads", formId);

    const ratingSnap = await getDoc(ratingDocRef);

    let totalRating = 0;
    let numRatings = 0;
    let prevUserRating = 0;

    if (ratingSnap.exists()) {
      const data = ratingSnap.data();
      totalRating = data.totalRating || 0;
      numRatings = data.numRatings || 0;
      prevUserRating = data.userRatings?.[user.uid] || 0;

      const newTotalRating = totalRating - prevUserRating + rating;
      const newNumRatings = prevUserRating === 0 ? numRatings + 1 : numRatings;
      const avgRating = newNumRatings > 0 ? newTotalRating / newNumRatings : 0;

      await updateDoc(ratingDocRef, {
        totalRating: newTotalRating,
        numRatings: newNumRatings,
        [`userRatings.${user.uid}`]: rating,
        updatedAt: new Date()
      });

      // 🔥 Update uploads collection also
      await updateDoc(uploadDocRef, {
        totalRating: newTotalRating,
        numRatings: newNumRatings,
        avgRating: avgRating
      });

      // Update filteredForms
      setFilteredForms(prev =>
        prev.map(f =>
          f.id === formId
            ? { ...f, avgRating: avgRating, numRatings: newNumRatings }
            : f
        )
      );

      // 🔥 ALSO update allForms
      setAllForms(prev =>
        prev.map(f =>
          f.id === formId
            ? { ...f, avgRating: avgRating, numRatings: newNumRatings }
            : f
        )
      );


    } else {
      // First rating ever
      await setDoc(ratingDocRef, {
        totalRating: rating,
        numRatings: 1,
        userRatings: { [user.uid]: rating },
        createdAt: new Date(),
        updatedAt: new Date()
      });

      await updateDoc(uploadDocRef, {
        totalRating: rating,
        numRatings: 1,
        avgRating: rating
      });

      setFilteredForms(prev =>
        prev.map(f =>
          f.id === formId
            ? { ...f, avgRating: rating, numRatings: 1 }
            : f
        )
      );
    }

  } catch (error) {
    console.error("Error updating rating:", error);
  }
};

 

  const handleDownload = async (form) => {
    const uploadRef = doc(db, 'uploads', form.id);
    await updateDoc(uploadRef, { downloads: increment(1) });

    const user = auth.currentUser;
    window.open(form.fileLink, '_blank');

      // Save download activity
  if (user) {
    await addDoc(collection(db, 'Downloads_And_Generations'), {
      userId: user.uid,
      email: user.email,
      action: 'Download',
      fileName: form.title,
      fileUrl: form.fileLink,
      subject: form.subject,
      type: form.type,
      standard: form.standard,
      timestamp: new Date()
    });
  }

    setFilteredForms(prev =>
      prev.map(f => f.id === form.id ? { ...f, downloads: f.downloads + 1 } : f)
    );
  };

  const handleFeedback = async (formId, type) => {
    const user = auth.currentUser;
    if (!user) return alert('Please log in to vote.');

    const feedbackRef = doc(db, 'formFeedback', `form${formId}`);
    const userVoteRef = doc(db, 'formFeedback', `form${formId}_user_${user.uid}`);

    const feedbackSnap = await getDoc(feedbackRef);
    const userVoteSnap = await getDoc(userVoteRef);

    if (!feedbackSnap.exists()) {
      await setDoc(feedbackRef, { thumbsUp: 0, thumbsDown: 0 });
    }

    let currentVote = userVotes[formId];

    if (currentVote === type) {
      await Promise.all([
        updateDoc(feedbackRef, { [type]: increment(-1) }),
        setDoc(userVoteRef, { vote: null, starRating: starRatings[formId] || 0})
      ]);
      setUserVotes((prev) => ({ ...prev, [formId]: null }));
      setFeedbackCounts((prev) => ({
        ...prev,
        [formId]: { ...prev[formId], [type]: prev[formId][type] - 1 },
      }));
    } else {
      const updates = [
        updateDoc(feedbackRef, {
          [type]: increment(1),
          ...(currentVote ? { [currentVote]: increment(-1) } : {})
        }),
        setDoc(userVoteRef, { vote: type, starRating: starRatings[formId] || 0})
      ];
      await Promise.all(updates);
      setUserVotes((prev) => ({ ...prev, [formId]: type }));
      setFeedbackCounts((prev) => ({
        ...prev,
        [formId]: {
          ...prev[formId],
          [type]: prev[formId][type] + 1,
          ...(currentVote ? { [currentVote]: prev[formId][currentVote] - 1 } : {}),
        },
      }));
    }
  };

  const handleGenerateAI = async (form) => {
    const user = auth.currentUser;
    if (!user) return alert("Please log in first.");

    const storage = getStorage();
    const folderRef = ref(storage, 'AI_Tests_By_Admin');
    const prefix = `Std_${form.standard}_${form.subject}_Test`;

    setLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 3000));
      const allItems = await listAll(folderRef);
      const allMatching = allItems.items.filter(item => item.name.startsWith(prefix));

      if (allMatching.length === 0) {
        setLoading(false);
        return alert("No AI tests available for this subject and standard.");
      }

      const shownQuery = query(
        collection(db, 'Shown_AI_Tests'),
        where('userId', '==', user.uid),
        where('standard', '==', form.standard),
        where('subject', '==', form.subject)
      );
      const shownSnap = await getDocs(shownQuery);
      const shownNames = shownSnap.docs.map(doc => doc.data().fileName);

      let available = allMatching.filter(item => !shownNames.includes(item.name));
      let reused = false;

      if (available.length === 0) {
        available = allMatching;
        reused = true;
      }

      const selected = available[Math.floor(Math.random() * available.length)];
      const fileUrl = await getDownloadURL(selected);

      await addDoc(collection(db, 'Shown_AI_Tests'), {
        userId: user.uid,
        standard: form.standard,
        subject: form.subject,
        fileName: selected.name,
        fileUrl: fileUrl,
        reused: reused,
        timestamp: new Date()
      });

      // ✅ Save generation activity
      await addDoc(collection(db, 'Downloads_And_Generations'), {
        userId: user.uid,
        email: user.email,
        action: 'GenerateWithAI',
        fileName: selected.name,
        fileUrl: fileUrl,
        subject: form.subject,
        type: 'AI Test',
        standard: form.standard,
        timestamp: new Date()
      });

      window.open(fileUrl, '_blank');
    } catch (error) {
      console.error("AI generation error:", error);
      alert("Failed to generate AI file.");
    }
    setLoading(false);
  };

  const subjects = ['All Subjects', ...new Set(allForms.map(f => f.subject))];

  // Total files after filters (before hiding downloaded)
const totalFiles = filteredForms.length;

// How many of those filtered files are already downloaded
const totalDownloaded = filteredForms.filter(form =>
  downloadedFileIds.includes(form.fileLink)
).length;

// Total left to download
const totalLeft = totalFiles - totalDownloaded;


return (
  <div className="px-4 py-6 max-w-7xl mx-auto font-sans">

    <BackHomeButton backState={{ subject: incomingSubject }} />

    <h2 className="text-2xl font-semibold text-center mb-6">
      {selectedType === 'Worksheet' ? 'Download Worksheets' : 'Download AI Generated Worksheets '}
    </h2>

    {/* Filters */}
    <div className="flex flex-wrap gap-4 mb-6 justify-between items-center">
      <input
        type="text"
        placeholder="Search by user, title, lesson, topics..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="flex-1 min-w-[200px] px-3 py-2 border rounded-lg border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-400"
      />

      <div className="flex flex-wrap gap-3 items-center text-sm">
        📁 Total Files: {totalFiles} | ✅ Downloaded: {totalDownloaded} | ⬇ Left: {totalLeft}
        <label className="flex items-center gap-1">
          <input
            type="checkbox"
            checked={hideShared}
            onChange={(e) => setHideShared(e.target.checked)}
          />
          Show Files Shared with Me
        </label>
      </div>
    </div>

    {/* Sort & Type Filters */}
    <div className="flex flex-wrap gap-4 mb-6">
      <select
        value={sortOption}
        onChange={(e) => setSortOption(e.target.value)}
        className="px-3 py-2 border rounded-lg border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        <option value="newest">Newest</option>
        <option value="rating">Highest Rated ⭐</option>
        <option value="downloads">Most Downloads 📥</option>        
      </select>

      <select
        value={selectedSubject}
        onChange={(e) => setSelectedSubject(e.target.value)}
        className="px-3 py-2 border rounded-lg border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        {subjects.map(sub => <option key={sub} value={sub}>{sub}</option>)}
      </select>

      <select
        value={selectedType}
        onChange={(e) => setSelectedType(e.target.value)}
        className="px-3 py-2 border rounded-lg border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        <option value="All Types">All Types</option>
        <option value="AI_Worksheet">AI Worksheets</option>
        <option value="Worksheet">Parent Worksheets</option>
        <option value="Assessment">School Assessment</option>
      </select>

      <select
        value={selectedStandard}
        onChange={(e) => setSelectedStandard(e.target.value)}
        className="px-3 py-2 border rounded-lg border-gray-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        <option value="All_Standard">All Standard</option>
        <option value="My_Standard">My Standard</option>
      </select>
    </div>

   
{/* Forms Grid */}
<div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-6">
  {visibleForms.map(form => (
    <div key={form.id} className="bg-white rounded-2xl shadow-md hover:shadow-xl transition overflow-hidden border">

              {/* File Preview */}
              
                <div
                  className={`bg-gray-100 flex items-center justify-center ${
                    form.fileLink?.toLowerCase().includes('.pdf')
                      ? "h-[400] lg:h-[450px]"
                      : "h-[400px] lg:h-[450px]"
                  }`}
                >
                {form.fileLink?.toLowerCase().includes('.pdf') ? (
                  /Android/i.test(navigator.userAgent) ? (
                    <iframe
                      src={`https://docs.google.com/gview?url=${encodeURIComponent(form.fileLink)}&embedded=true`}
                      title="preview"
                      loading="lazy"
                      className="w-full h-full"
                    />
                  ) : (
                    <iframe
                      src={`${form.fileLink}#toolbar=0&navpanes=0&scrollbar=1`}
                      title="preview"
                      loading="lazy"
                      className="w-full h-full"
                    />
                  )
                ) : (
                  <img
                    src={form.fileLink}
                    alt="preview"
                    loading="lazy"
                    className="object-cover w-full h-full"
                  />
                )}
              </div>
              

      {/* File Name */}
      <h3 className="px-3 pt-2 font-semibold text-gray-800 text-sm truncate" title={form.title}>
        {form.title}
      </h3>

      {/* Details */}
    <div className="border rounded-xl bg-white shadow-sm">
      
      {/* Header (Clickable) */}
      <button
        onClick={() =>
          setOpenId(openId === form.id ? null : form.id)
        }
        className="w-full flex items-center justify-between px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-xl"
      >
        <span>Details</span>
        <ChevronDown
          className={`w-4 h-4 transition-transform duration-300 ${
            openId === form.id ? "rotate-180" : ""
          }`}
        />
      </button>

      {/* Collapsible Content */}
      <div
        className={`overflow-hidden transition-all duration-300 ${
          openId === form.id
              ? "max-h-96 opacity-100"
              : "max-h-0 opacity-0"
        }`}
      >
        <div className="px-3 pb-3 pt-1 text-xs text-gray-600 space-y-1">
          <p>Lesson: {form.lessonName}</p>
          <p>Uploaded By: {form.uploadedBy}</p>
          <p>Type: {form.type}</p>
          <p>School: {form.school}</p>
          <p>Standard: {form.standard}</p>
          <p>Topics: {form.topics}</p>
          {form.uploadTime && (
            <p>
              Uploaded on: {form.uploadTime.toLocaleDateString()}
            </p>
          )}
        </div>
      </div>
    </div>

      {/* User Reviews & Rating */}
      <div className="px-3 pb-2 pt-1 text-sm border-t border-gray-200">
        <h4 className="font-semibold mb-1 text-gray-700">User Reviews & Rating</h4>
        <div className="flex items-center justify-between text-xs mb-1">
          <span className="text-gray-600">Average Rating:</span>
          <span className="font-bold text-gray-800">{form.avgRating?.toFixed(1) || '0.0'} ⭐</span>
        </div>

        <div className="flex items-center gap-1">
          {[1,2,3,4,5].map(star => (
            <span
              key={star}
              onClick={() => handleStarRating(form.id, star)}
              className={`cursor-pointer ${ (userStarRatings[form.id] || 0) >= star ? 'text-yellow-400' : 'text-gray-300' }`}
            >
              ★
            </span>
          ))}
          <span className="text-gray-500 text-xs ml-2">(Click to rate)</span>
        </div>
      </div>

      {/* Buttons */}
      <div className="px-3 pb-3 flex flex-wrap gap-2 mt-2">
        <button
          onClick={() => handleDownload(form)}
          className="flex-1 bg-blue-500 hover:bg-blue-600 text-white py-2 rounded-lg text-xs"
        >
          Download {form.downloads}
        </button>

        <button
          onClick={() =>
            navigate("/Email_Worksheet", { state: { fileId: form.id } })
          }
          className="flex-1 bg-blue-500 hover:bg-blue-600 text-white py-2 rounded-lg text-xs"
        >
          Share {form.shares}
        </button>

      {/* Report */}
      
        <button
          onClick={() => handleReport(form)}
          disabled={form.reportedBy?.[auth.currentUser?.uid]}
          className="flex-1 bg-red-500 hover:bg-blue-600 text-white py-2 rounded-lg text-xs"
        >
          {form.reportedBy?.[auth.currentUser?.uid]
            ? `Reported (${form.reportCount || 0})`
            : `Report (${form.reportCount || 0})`}
        </button>
      

        {form.type === 'Test' && (
          <button
            onClick={() => handleGenerateAI(form)}
            className="flex-1 bg-green-500 hover:bg-green-600 text-white py-2 rounded-lg text-xs"
          >
            Generate with AI
          </button>
        )}
      </div>


<div className="px-2 mt-1 flex items-center gap-2 whitespace-nowrap text-[11px]">
  
  {downloadedFileIds.includes(form.fileLink) && (
    <span className="bg-green-100 text-green-700 px-2 py-0.5 rounded">
      ✔ Already Downloaded
    </span>
  )}

</div>

    </div>
  ))}
</div>

    {/* Loading Overlay */}
    {loading && (
      <div className="fixed inset-0 bg-white bg-opacity-90 flex justify-center items-center text-blue-600 font-bold text-lg z-50">
        Generating AI file, please wait...
      </div>
    )}
  </div>
);

}

// ---------- 🔧 Style Object ----------


export default DownloadForms;
